import Cookies from 'js-cookie';

/** Specific country-region pairs that require consent (checked first).
 *  Format: "{country}-{region}" using ISO 3166-2 subdivision codes. */
const CONSENT_REGIONS = new Set([
  'US-CA', // California — CPRA
]);

/** Countries where consent is required nationwide.
 *  EU-27 + EEA (IS, LI, NO) + UK + Switzerland. */
const CONSENT_COUNTRIES = new Set([
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE', // EU 27
  'IS',
  'LI',
  'NO', // EEA
  'GB', // UK GDPR
  'CH', // Swiss FADP (nDSG)
]);

/**
 * Determine if the visitor is in a region that requires cookie consent.
 * Reads __cf_geo and __cf_geo_region cookies set by the Cloudflare Worker.
 * Returns false (no consent required) when cookies are missing.
 *
 * Must be called client-side only.
 */
export function isGDPRRegion(): boolean {
  const country = Cookies.get('__cf_geo')?.toUpperCase();
  if (!country) return false; // Unknown → treat as non-GDPR

  // Check region-specific rules first (e.g., US-CA for CPRA)
  const region = Cookies.get('__cf_geo_region')?.toUpperCase();
  if (region && CONSENT_REGIONS.has(`${country}-${region}`)) {
    return true;
  }

  // Fall back to country-level check
  return CONSENT_COUNTRIES.has(country);
}
